<app-navbar-style-three></app-navbar-style-three>

<app-living-room-products></app-living-room-products>

<app-bedroom-products></app-bedroom-products>

<app-kitchen-room-products></app-kitchen-room-products>
